import React, { useState, useEffect } from 'react';
import toast from 'react-hot-toast';
import cn from 'classnames';

import { 
  UNIT_TYPE_WITHOUT_AMOUNT,
  unitTypeLabels,
 } from '../../constants/unitTypes';
import IngredientDropDown from './IngredientsDropDown';
import styles from './IngredientsSelect.module.css';

const IngredientsSelect = (props) => {
  const { 
    initialIngredients, 
    ingredientsData,
    onChange,
   } = props;

  const [currentAlternative, setCurrentAlternative] = useState(null);
  const [selectedIngredients, setSelectedIngredients] = useState([]);
  
  
  useEffect(() => {
  setCurrentAlternative(null);

  if (!initialIngredients?.length || !ingredientsData?.length) {
    setSelectedIngredients([]);
    return;
  }

  const hydrated = initialIngredients
    .map((ingredient) => {
      const ingredientId = ingredient?.id ?? ingredient;
      const ingredientData = ingredientsData.find((i) => i.id == ingredientId);
      if (!ingredientData) return null;

      return {
        ...ingredientData,
        amount: ingredient.amount ?? ingredientData.amount ?? '',
        is_required: ingredient.is_required ?? ingredientData.is_required ?? 0,
      };
    })
    .filter(Boolean);

  setSelectedIngredients(hydrated);
}, [initialIngredients, ingredientsData]);

  
const changeAlternativeHandler = (event) => {
  const { value } = event.target;
  if (!value) {
    setCurrentAlternative(null);
    return;
  }

  const selectedIngredient = ingredientsData.find((i) => i.id == value);
  if (!selectedIngredient) return;

  // If already added, just focus it (or ignore)
  if (selectedIngredients.some((i) => i.id === selectedIngredient.id)) {
    toast.error('Ingredient already added');
    return;
  }

  // Auto-commit: immediately add to the list
  const requiresAmount = selectedIngredient.unit_type !== UNIT_TYPE_WITHOUT_AMOUNT;
  const newEntry = {
    ...selectedIngredient,
    amount: requiresAmount ? '' : 0,
    is_required: requiresAmount ? 1 : 0,
  };

  commitIngredients([...selectedIngredients, newEntry]);

  // Reset the dropdown — the amount can be edited inline in the list
  setCurrentAlternative(null);
  
};

 const commitIngredients = (next) => {
  setSelectedIngredients(next);
  onChange(next);
};



  return (
    <>
      <div className={cn(styles.alternativeBlock, styles.withAmount)}>
        <IngredientDropDown 
          value={currentAlternative?.id || ''}
          onChange={changeAlternativeHandler}
          ingredientsData={ingredientsData}
        />

      </div>
      <div className={styles.alternativeList}>
  {selectedIngredients.map((ingredient, index) => (
    <div className={styles.selectedAlternative} key={`${ingredient.id}.${index}`}>
      <span className={styles.ingredientName}>{ingredient.name}</span>

      {ingredient.unit_type !== UNIT_TYPE_WITHOUT_AMOUNT && (
        <div className={styles.amount}>
          <span className={styles.unitType}>
            {unitTypeLabels[ingredient.unit_type]}:
          </span>
          <input
            type="number"
            className={styles.input}
            value={ingredient.amount}
            onChange={(e) => {
              const next = [...selectedIngredients];
              next[index] = { ...ingredient, amount: e.target.value };
              commitIngredients(next);
            }}
          />
        </div>
      )}

      <div
        className={styles.delete}
        onClick={() => {
          const next = selectedIngredients.filter((_, i) => i !== index);
          commitIngredients(next);
        }}
      >
        ×
      </div>
    </div>
  ))}
</div>
    </>
  );
};

export default IngredientsSelect;